import { defineMessages } from 'react-intl'

export default defineMessages({
  error: {
    id: 'components.PreviewFile.error',
    defaultMessage: 'Failed to load file: {error}',
  },
  loading: {
    id: 'components.PreviewFile.loading',
    defaultMessage: 'Loading file...',
  },
})
